import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allEmailRecipients: [],
  createEmailRecipient: {},
  emailRecipient: [],
  updateEmailRecipient: [],
  deleteEmailRecipient: {},
  customerEmailRecipients: [],
  customerEmailRecipientsByType: [],
  customerSiemRecipientsbyType: [],
  addCustomerSiemRecipient: {},
  updateCustomerSiemRecipient: {},
  deleteCustomerSiemRecipient: {},
  deleteEmailRecipients: {},
  editEmailRecipients: {},
  error: null,
  isLoading: false,
  customerEmailRecipientsbyIdAndTypeSiem: [],
  customerEmailRecipientsbyIdAndTypeAuvik: [],
  customerEmailRecipientsbyIdAndTypeSentinelOne: [],
  customerEmailRecipientsbyIdAndTypeMSSentinel: [],
  customerEmailRecipientsbyIdAndTypePaloAlto: [],
  addEmailRecipients: [],
  customerEmailRecipientsSupportTicket: [],
  customerEmailRecipientsbyIdAndTypeExaBeam: [],
  customerEmailRecipientsbyIdAndTypeLowInventory: [],
};

const emailRecipientSlice = createSlice({
  name: 'emailRecipients',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllEmailRecipients: (state, action) => {
      state.allEmailRecipients = action.payload;
      state.error = null;
    },
    setEmailRecipient: (state, action) => {
      state.emailRecipient = action.payload;
      state.error = null;
    },
    setCreateEmailRecipient: (state, action) => {
      state.createEmailRecipient = action.payload;
      state.error = null;
    },
    setUpdateEmailRecipient: (state, action) => {
      state.updateEmailRecipient = action.payload;
      state.error = null;
    },
    setDeleteEmailRecipient: (state, action) => {
      state.deleteEmailRecipient = action.payload;
      state.error = null;
    },
    setCustomerEmailRecipients: (state, action) => {
      state.customerEmailRecipients = action.payload;
      state.error = null;
    },
    setCustomerEmailRecipientsByType: (state, action) => {
      state.customerEmailRecipientsByType = action.payload;
      state.error = null;
    },
    setCustomerSiemRecipientsbyType: (state, action) => {
      state.customerSiemRecipientsbyType = action.payload;
      state.error = null;
    },
    setAddCustomerSiemRecipient: (state, action) => {
      state.addCustomerSiemRecipient = action.payload;
      state.error = null;
    },
    setUpdateCustomerSiemRecipient: (state, action) => {
      state.updateCustomerSiemRecipient = action.payload;
      state.error = null;
    },
    setDeleteCustomerSiemRecipient: (state, action) => {
      state.deleteCustomerSiemRecipient = action.payload;
      state.error = null;
    },
    setCustomerEmailRecipientsbyIdAndTypeSiem: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeSiem = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypeAuvik: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeAuvik = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypeSentinelOne: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeSentinelOne = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypeMSSentinel: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeMSSentinel = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypePaloAlto: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypePaloAlto = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypeExaBeam: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeExaBeam = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAddEmailRecipients: (state, action) => {
      state.addEmailRecipients = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setEditEmailRecipients: (state, action) => {
      state.editEmailRecipients = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeleteEmailRecipients: (state, action) => {
      state.deleteEmailRecipients = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyIdAndTypeSupportTicket: (state, action) => {
      state.customerEmailRecipientsSupportTicket = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerEmailRecipientsbyIdAndTypeLowInventory: (state, action) => {
      state.customerEmailRecipientsbyIdAndTypeLowInventory = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetAlertEmailRecipients: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllEmailRecipients,
  setEmailRecipient,
  setCreateEmailRecipient,
  setUpdateEmailRecipient,
  setDeleteEmailRecipient,
  setCustomerEmailRecipients,
  setCustomerEmailRecipientsbyType,
  setCustomerSiemRecipientsbyType,
  setAddCustomerSiemRecipient,
  setUpdateCustomerSiemRecipient,
  setDeleteCustomerSiemRecipient,
  setCustomerEmailRecipientsbyIdAndTypeSiem,
  setCustomerEmailRecipientsbyIdAndTypeAuvik,
  setCustomerEmailRecipientsbyIdAndTypeSentinelOne,
  setCustomerEmailRecipientsbyIdAndTypeMSSentinel,
  setCustomerEmailRecipientsbyIdAndTypePaloAlto,
  setAddEmailRecipients,
  setDeleteEmailRecipients,
  setEditEmailRecipients,
  setCustomerEmailRecipientsbyIdAndTypeSupportTicket,
  setResetAlertEmailRecipients,
  setCustomerEmailRecipientsbyIdAndTypeExaBeam,
  setCustomerEmailRecipientsbyIdAndTypeLowInventory,
} = emailRecipientSlice.actions;

export default emailRecipientSlice.reducer;
